import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { AlertCircle } from 'lucide-react';

export default function ProtectedRoute({ 
  children, 
  requiredPermission, 
  requiredRole 
}) {
  const { user, hasPermission, hasRole } = useAuth();

  if (!user) {
    return null;
  }

  // Si es ADMIN, tiene acceso total (opcional, podrías comentar esto para ser 100% estricto con permisos)
  if (hasRole('ADMIN')) return <>{children}</>;


  // Verificar permisos específicos
  if (requiredPermission && !hasPermission(requiredPermission)) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="max-w-md w-full bg-white rounded-lg shadow p-6 text-center">
          <AlertCircle className="h-12 w-12 text-red-500 mx-auto mb-4" />
          <h2 className="text-xl font-semibold text-gray-900 mb-2">Acceso Denegado</h2>
          <p className="text-gray-600 mb-4">
            No tienes permisos suficientes para acceder a esta sección.
          </p>
          <p className="text-sm text-gray-500">
            Contacta al administrador si necesitas acceso.
          </p>
        </div>
      </div>
    );
  }

  // Verificar roles específicos
  if (requiredRole && !hasRole(requiredRole)) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="max-w-md w-full bg-white rounded-lg shadow p-6 text-center">
          <AlertCircle className="h-12 w-12 text-red-500 mx-auto mb-4" />
          <h2 className="text-xl font-semibold text-gray-900 mb-2">Acceso Restringido</h2>
          <p className="text-gray-600 mb-4">
            Esta sección está disponible solo para usuarios con rol de {requiredRole}.
          </p>
          <p className="text-sm text-gray-500">
            Tus roles: <span className="font-medium">{user.roles?.join(', ')}</span>
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
